const sides: Record<string, { label: string; value: string }[]> = {
  hip_joint: [
    {
      label: "Левая",
      value: "left",
    },
    {
      label: "Правая",
      value: "right",
    },
  ],
  spine: [
    {
      label: "sacrum",
      value: "sacrum",
    },
    {
      label: "C1",
      value: "C1",
    },
    {
      label: "C2",
      value: "C2",
    },
    {
      label: "C3",
      value: "C3",
    },
    {
      label: "C4",
      value: "C4",
    },
    {
      label: "C5",
      value: "C5",
    },
    {
      label: "C6",
      value: "C6",
    },
    {
      label: "C7",
      value: "C7",
    },
    {
      label: "T1",
      value: "T1",
    },
    {
      label: "T2",
      value: "T2",
    },
    {
      label: "T3",
      value: "T3",
    },
    {
      label: "T4",
      value: "T4",
    },
    {
      label: "T5",
      value: "T5",
    },
    {
      label: "T6",
      value: "T6",
    },
    {
      label: "T7",
      value: "T7",
    },
    {
      label: "T8",
      value: "T8",
    },
    {
      label: "T9",
      value: "T9",
    },
    {
      label: "T10",
      value: "T10",
    },
    {
      label: "T11",
      value: "T11",
    },
    {
      label: "T12",
      value: "T12",
    },
    {
      label: "L1",
      value: "L1",
    },
    {
      label: "L2",
      value: "L2",
    },
    {
      label: "L3",
      value: "L3",
    },
    {
      label: "L4",
      value: "L4",
    },
    {
      label: "L5",
      value: "L5",
    },
  ],
};

export default sides;
